import Cookie from 'oatmeal-cookie'

import { qa, u } from './util/helpers'
import { locale } from './util/locale'


export default function initSubscribe() {

  const subscribeForms = qa('[subscribe-form]');

  subscribeForms.forEach((subscribeForm) => {
    const slug = subscribeForm.getAttribute('slug');

    const submitBtn = u(subscribeForm).q('[subscribe-submit]');
    const input = u(subscribeForm).q('input[type="email"]')

    subscribeForm.on('submit', (e) => {
      e.preventDefault()

      if (input.validity.typeMismatch) {
        const validity = window.MBS_LOCALIZE.checkEmail;
        input.setCustomValidity(validity);
        input.setAttribute('placeholder', validity);
        input.value = null;
        input.classList.add('--error');
        return;
      }

      if (input.validity.valueMissing) {
        input.classList.add('--error')
        return
      }

      submitBtn.classList.add('--loading');
      const email = new FormData(subscribeForm).get('email');
      subscribe(email);
    });

    function setFormAsSuccess() {
      subscribeForm.classList.add('--success');
      submitBtn.classList.add('--success');
      submitBtn.classList.remove('--loading');
      // TODO: localize
      // const btnSuccessText = window.STRING_TRANSLATIONS.succes_btn[locale.short];
      submitBtn.textContent = window.MBS_LOCALIZE.success;
      submitBtn.setAttribute('disabled', true);
      input.setAttribute('disabled', true);
      input.classList.remove('--error');
    }

    function setFormAsServerError() {
      submitBtn.classList.remove('--loading');
      submitBtn.setAttribute('disabled', true);
      submitBtn.textContent = window.MBS_LOCALIZE.serverError;
      input.classList.add('--error');
    }

    function subscribe(email) { // eslint-disable-line
      const mindbox = {
         customer: {
          email,
          area: {
            ids: {
              externalId: locale.short,
            },
          },
          subscriptions: [{
            brand: 'Travelpayouts',
            pointOfContact: 'Email',
          } ],
        },
        addProductToList: {
          product: {
            ids: {
              landings: slug,
            },
          },
        },
        pointOfContact: 'main',
      }

      function getFormData(object) {
          const formData = new FormData();
          Object.keys(object).forEach(key => formData.append(key, object[key]));
          return formData;
      }

      function objectParametize(obj, delimeter, q) {
          var str = new Array();
          if (!delimeter) delimeter = '&';
          for (var key in obj) {
              switch (typeof obj[key]) {
                  case 'string':
                  case 'number':
                      str[str.length] = key + '=' + obj[key];
                  break;
                  case 'object':
                      str[str.length] = objectParametize(obj[key], delimeter);
              }
          }
          return (q === true ? '?' : '') + str.join(delimeter);
      }

        const payload = {
          action: 'mindbox',
          webhooker: {
            event: 'email_input',
            page_url: window.location.href,
            page_referrer: document.referrer,
            user_agent: navigator.userAgent,
            event_context: {
              attr_parameters: {},
              marker: Cookie.get('marker') || null,
              email,
            },
          },
          mindbox,
        }

        // from cookies
        ;[
          'utm_source',
          'utm_medium',
          'utm_campaign',
          'utm_term',
          'utm_content',
          'promotion_code_id',
          'referral_marker',
          'ad_source',
          'ad_content',
          'tp_referrer',
        ].forEach((cookieName) => {
          payload.webhooker.event_context.attr_parameters[cookieName] = Cookie.get(cookieName) || null
        })

        // oh I'm dying inside but it's easier to have this data stringified
        // the jquery way
        window.jQuery.ajax({
            url: MBSUBSCRIBE.ajaxUrl,
            method: 'post',
            data: {
                action: 'mindbox',
                ...payload
            },
            success,
            error,
        });

        function success(bodyStr) {
          const body = JSON.parse(bodyStr)
          if (body.mindbox.status === 'Success') {
            setFormAsSuccess()
          }
        }

        function error(error) {
          setFormAsServerError();
          console.error('mindbox error', error);
        }
    }

  });
}
